module.exports = "/labor-cost/components/laborCostSettings-d71368.html";